<template>

  <div>

    <div :id="_uid" class="ui small modal" :class="modalSelector">
      <div class="ui header">
        {{ isCreating ? "Nova Raça" : "Alterar Raça" }}
      </div>
      <div class="content">
        <div class="ui form" :class="{ loading: loadingSpecies }">
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Espécie <span class="red text">*</span></label>
              <select-dropdown ref="speciesDropdown" @onChange="onChangeSpecies" />
            </div>     
          </div>
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Nome da Raça <span class="red text">*</span></label>
              <input class="uppercase" v-model="race.name" @blur="race.name = $toUpperCase($event)">
            </div>     
          </div>
        </div>
      </div>
      <div class="actions">
        <button class="ui cancel basic button">
          <i class="times icon"></i>
          Cancelar
        </button>      
        <button v-if="isUpdating" class="ui basic red button" 
          :class="{ loading: checkingRemoval || removing }" @click="onRemove()">
          <i class="trash icon"></i> Excluir
        </button>
        <button class="ui blue button" :class="{ loading: saving, disabled: !race.speciesId || !race.name || removing }" 
          @click="onConfirm()">
          <i class="checkmark icon"></i>
          {{ isCreating ? "Confirmar" : "Atualizar" }}
        </button>
      </div>
    </div>

    <can-not-remove-modal ref="canNotRemoveModal" />

    <yes-no-modal ref="confirmRemovalModal" :message="'Confirma exclusão da raça ' + race.name + ' ?'" 
      :danger="true" @onYes="onConfirmRemoval()"/>

  </div>
  
</template>

<script>

  import modalDialog from "@/mixins/modal-dialog"
  import SpeciesService from "@/services/species-service"
  import RaceService from "@/services/race-service"
  import SelectDropdown from "@/components/select-dropdown"

  export default {

    name: "RaceFormModal",

    mixins: [modalDialog],

    data() {
      return {
        loadingSpecies: true,
        species: [],
        race: {},
        service: new RaceService(),
        speciesService: new SpeciesService(),
      }
    },

    components: {
      SelectDropdown,
    },
    
    methods: {

      load(race) {
        
        this.loadingSpecies = true
        this.race = {}
        
        this.$refs.speciesDropdown.clear()

        if (race)
          this.race = this.$cloneObject(race)

        this.show()
      },

      onVisible() {
        this.loadSpecies()
      },

      async loadSpecies() {

        this.loadingSpecies = true

        try {

          if (this.species.length == 0) {
            this.species = await this.speciesService.findAll({
              attributes: ["id", "name"],
              order: ["name"],
            })
          }  

          this.$refs.speciesDropdown.setValues(this.species, this.race.speciesId)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loadingSpecies = false
        }
      },

      onChangeSpecies(id) {
        this.race.speciesId = id
      },

      async onConfirm() {

        if (this.saving)
          return

        this.saving = true
        
        try {

          if (this.isCreating) {
            await this.service.create(this.race)
          } else {            
            await this.service.update(this.race)            
          }

          this.emit("onSave", this.race)

          this.$msg.success(this.isCreating ? "Raça criada com sucesso" : "Raça alterada com sucesso")
          
        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.saving = false
        }
      },

      async onRemove() {

        this.checkingRemoval = true

        try {

          const data = await this.service.canRemove(this.race)

          if (data.canRemove)  {
            this.$refs.confirmRemovalModal.show()              
          } else {
            this.$refs.canNotRemoveModal.show(data.entities)            
          }

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.checkingRemoval = false
        }        
      },

      async onConfirmRemoval() {

        if (this.removing)
          return

        this.removing = true

        try {

          await this.service.remove(this.race) 

          this.emit("onRemove", this.race)

          this.$msg.success("Raça excluída com sucesso")
          
        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.removing = false
        }
      },
    },
  }

</script>
